import React, { useState, useEffect, useContext } from 'react'
import { useParams, useNavigate } from 'react-router-dom'
// import currentNewsData from '../data/currentNews.json'
import {
  Container,
  Button,
  Modal,
  Form,
  Alert,
  Spinner,
  ProgressBar,
} from 'react-bootstrap'
import { Formik } from 'formik'
import * as yup from 'yup'
// import { v4 as uuidv4 } from 'uuid'
import axios from 'axios'
import parse from 'html-react-parser'
import Cookies from 'js-cookie'
import { AuthContext } from './AuthContext'

const CurrentNews = ({
  currentUser,
  extendCookie,
  sendDiscordNotification,
}) => {
  const { baseUrl } = useContext(AuthContext)
  const detailUrl = '/api/crm/news/detail'
  const consultUrl = '/api/crm/news/consult'
  const { newsId } = useParams()

  const [inquire, setInquire] = useState(false)
  const [inquireSuccess, setInquireSuccess] = useState(false)
  const [AlertShow, setAlertShow] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [isInquireLoading, setisInquireLoading] = useState(false)
  const [currentNews, setCurrentNews] = useState({
    title: '',
    content: '',
    type: 0,
  })

  function getSession() {
    return new Promise((resolve, reject) => {
      const sessionFromCookie = Cookies.get('session')
      if (sessionFromCookie) {
        const { session } = JSON.parse(sessionFromCookie)
        resolve(session)
      } else {
        resolve('')
      }
    })
  }

  useEffect(() => {
    setIsLoading(true)
    extendCookie()

    getSession().then((session) => {
      axios
        .post(
          baseUrl + detailUrl,
          {
            clinic_news_id: newsId,
          },
          {
            headers: {
              'Content-Type': 'application/json; charset=UTF-8',
              Accept: '*/*',
              session: currentUser?.session || session || '',
            },
          }
        )
        .then((res) => {
          // console.log('detail', res.data)

          if (res.data.title) {
            setCurrentNews(res.data)
          } else if (res.data.error?.code === '10031') {
            setCurrentNews({
              title: '醫療機構徵詢資訊不存在',
              content: '很抱歉，您所查看的醫療機構徵詢資訊不存在',
              type: 0,
            })
          } else if (res.data.error?.code === '50004') {
            // "50004" "登入狀態不存在"
            navigate('/')
          }
        })
        .catch((e) => {
          console.log('getList error', e)
          sendDiscordNotification(
            `CurrentNews Error \n Error: ${e} \n Session: ${session}`
          )
        })
        .finally(() => {
          setIsLoading(false)
        })
    })
  }, [])

  const navigate = useNavigate()
  // const currentNews =
  //   currentNewsData.find((v) => v.id === Number(newsId)) || sampleNews
  const parsedHtml = parse(currentNews?.content)
  // const unfilter = currentNews.content.split('')
  // const paragraphs = unfilter.filter((v, i) => !v.includes('https'))
  // const link = currentNews?.content
  //   .split('')
  //   .filter((v, i) => v.includes('https'))

  const handleInquireClose = () => setInquire(false)
  const handleInquireShow = () => setInquire(true)
  const handleSubmit = (values) => {
    // e.preventDefault()
    extendCookie(currentUser)
    setisInquireLoading(true)
    const requestBody = {
      name: values.name,
      tel: values.contactPhone,
      email: values.email,
      clinic_news_id: newsId,
    }

    // console.log('requestBody', requestBody)

    axios
      .post(baseUrl + consultUrl, requestBody, {
        headers: {
          'Content-Type': 'application/json; charset=UTF-8',
          Accept: '*/*',
          session: currentUser?.session,
        },
      })
      .then((res) => {
        // console.log('consult', res)
        if (res.data.message === '送出成功') {
          setInquireSuccess(true)
          setTimeout(() => {
            setInquireSuccess(false)
            setInquire(false)
          }, 3000)
        } else {
          setAlertShow(true)
        }
      })
      .catch((e) => {
        console.log('consult err', e)
        setAlertShow(true)
        sendDiscordNotification(
          `徵詢失敗 \n Error: ${e} \n Session: ${
            currentUser.session
          } \n RequestBody: ${JSON.stringify(requestBody)}`
        )
      })
      .finally(() => {
        setisInquireLoading(false)
      })
  }

  const vaildSchema = yup.object().shape({
    name: yup.string().required('*聯絡人姓名不得空白'),
    contactPhone: yup.string().required('*連絡電話不得空白'),
    email: yup.string().email('*電子郵件格式有誤').required('*Email 不得空白'),
  })

  return (
    <>
      <div className="containerOverflow">
        <Container className="currentNews">
          <Button
            variant="outline-primary"
            onClick={() => {
              navigate('/')
            }}
            className="backToList"
          >
            <i className="fa fa-angle-double-left"></i> 回到最新消息列表
          </Button>
          {isLoading ? (
            <div className="m-5">
              <ProgressBar className="m-4" animated now={100} />
              <h5 className="text-secondary text-center">資料等待中...</h5>
            </div>
          ) : (
            <>
              <h1 className="text-center">
                {currentNews ? currentNews.title : ''}
              </h1>

              <div className="content">{parsedHtml}</div>
            </>
          )}
          {/* <h5 className="source">
            來源: {currentNews ? currentNews.source : ''}
          </h5> */}
          <div className="inquiryButton d-flex align-items-center mt-5">
            {currentNews.type === 1 && (
              <Button
                onClick={handleInquireShow}
                size="lg"
                className="mx-auto mt-3"
              >
                我有意願徵詢
              </Button>
            )}
            <Modal
              show={inquire}
              onHide={handleInquireClose}
              aria-labelledby="contained-modal-title-vcenter"
              centered
            >
              <Modal.Header closeButton>
                <Modal.Title>聯絡人資訊</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <Formik
                  validationSchema={vaildSchema}
                  onSubmit={(values, { setSubmitting, resetForm }) => {
                    // When button submits form and form is in the process of submitting, submit button is disabled
                    // console.log('onSubmit', values)
                    setSubmitting(true)
                    handleSubmit(values)
                    // Resets form after submission is complete
                    setTimeout(() => {
                      resetForm()
                      setSubmitting(false)
                    }, 5000)
                    // Sets setSubmitting to false after form is reset
                  }}
                  initialValues={{
                    name: '',
                    contactPhone: '',
                    email: '',
                  }}
                >
                  {({
                    values,
                    errors,
                    touched,
                    handleChange,
                    handleBlur,
                    handleSubmit,
                    isValid,
                    isSubmitting,
                  }) => (
                    <>
                      <Form onSubmit={handleSubmit}>
                        <Form.Group className="mb-3" controlId="name">
                          <Form.Label>
                            聯絡人姓名
                            <span className="text-danger">*</span>
                          </Form.Label>
                          <Form.Control
                            type="text"
                            name="name"
                            value={values.name}
                            placeholder="王大明"
                            onBlur={handleBlur}
                            onChange={handleChange}
                            className={
                              touched.name && errors.name
                                ? 'border border-danger border-2'
                                : null
                            }
                            // value={name}
                            // onChange={(e) => setName(e.target.value)}
                          />
                          {touched.name && errors.name ? (
                            <div
                              style={{ fontSize: '13px' }}
                              className="text-danger"
                            >
                              {errors.name}
                            </div>
                          ) : null}
                        </Form.Group>
                        <Form.Group className="mb-3" controlId="contactPhone">
                          <Form.Label>
                            電話<span className="text-danger">*</span>
                          </Form.Label>
                          <Form.Control
                            type="tel"
                            name="contactPhone"
                            value={values.contactPhone}
                            onBlur={handleBlur}
                            onChange={handleChange}
                            placeholder="02-12345678 / 0912345678"
                            className={
                              touched.contactPhone && errors.contactPhone
                                ? 'border border-danger border-2'
                                : null
                            }
                            // value={phone}
                            // onChange={(e) => setPhone(e.target.value)}
                          />
                          {touched.contactPhone && errors.contactPhone ? (
                            <div
                              style={{ fontSize: '13px' }}
                              className="text-danger"
                            >
                              {errors.contactPhone}
                            </div>
                          ) : null}
                        </Form.Group>
                        <Form.Group className="mb-3" controlId="email">
                          <Form.Label>
                            Email<span className="text-danger">*</span>
                          </Form.Label>
                          <Form.Control
                            type="email"
                            name="email"
                            value={values.email}
                            onBlur={handleBlur}
                            onChange={handleChange}
                            placeholder="ha@example.com"
                            className={
                              touched.email && errors.email
                                ? 'border border-danger border-2'
                                : null
                            }
                            // value={email}
                            // onChange={(e) => setEmail(e.target.value)}
                          />
                          {touched.email && errors.email ? (
                            <div
                              style={{ fontSize: '13px' }}
                              className="text-danger"
                            >
                              {errors.email}
                            </div>
                          ) : null}
                        </Form.Group>
                        {AlertShow && (
                          <Alert
                            variant="danger"
                            onClose={() => setAlertShow(false)}
                            dismissible
                            // className="visually-hidden"
                          >
                            <i className="fa-solid fa-triangle-exclamation"></i>{' '}
                            伺服器忙碌中，請稍後再試
                          </Alert>
                        )}
                        {inquireSuccess && (
                          <Alert
                            variant="success"
                            onClose={() => setInquireSuccess(false)}
                            dismissible
                          >
                            <i className="fa-regular fa-face-smile"></i>
                            {'  '}
                            徵詢資訊已送出
                          </Alert>
                        )}
                        <Button
                          className="w-100 mt-2"
                          variant="primary"
                          type="submit"
                          // onClick={handleSubmit}
                          // onClick={(e) => {
                          //   handleSubmit(e, values)
                          // }}
                        >
                          送出
                          <Spinner
                            as="span"
                            animation={isInquireLoading ? 'border' : ''}
                            size="sm"
                            role="status"
                            aria-hidden="true"
                          />
                        </Button>
                      </Form>
                    </>
                  )}
                </Formik>
              </Modal.Body>
            </Modal>
          </div>
        </Container>
      </div>
    </>
  )
}

export default CurrentNews
